import Vue from 'vue';
import Router from 'vue-router';
import Ping from '@/components/Ping';
import Confirm from '@/components/Confirm';
import Cancel from '@/components/Cancel';
import Reschedule from '@/components/Reschedule';
import ConfirmExam from '@/components/Confirm_exam';
import CancelExam from '@/components/Cancel_exam';
import RescheduleExam from '@/components/Reschedule_exam';
import Books from '@/components/Books';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Books',
      component: Books,
    },
    {
      path: '/ping',
      name: 'Ping',
      component: Ping,
    },
    {
      path: '/v1/action/medical/appointment/confirm/pt_BR/:token/:task',
      name: 'Confirm',
      component: Confirm,
    },
    {
      path: '/v1/action/medical/appointment/cancel/pt_BR/:token/:task',
      name: 'Cancel',
      component: Cancel,
    },
    {
      path: '/v1/action/medical/appointment/reschedule/pt_BR/:token/:task',
      name: 'Reschedule',
      component: Reschedule,
    },
    {
      path: '/v1/action/medical/exam/confirm/pt_BR/:token/:task',
      name: 'ConfirmExam',
      component: ConfirmExam,
    },
    {
      path: '/v1/action/medical/exam/cancel/pt_BR/:token/:task',
      name: 'CancelExam',
      component: CancelExam,
    },
    {
      path: '/v1/action/medical/exam/reschedule/pt_BR/:token/:task',
      name: 'RescheduleExam',
      component: RescheduleExam,
    },
  ],
  mode: 'hash',
});



// WEBPACK FOOTER //
// ./src/router/index.js